import { UserProfession } from '~/enums/UserProfession';

/**
 * A profession as the shift request form holds it, a display name ("Expanded Functions DA"), as the
 * reduced code a rule or an analytics event wants ("DA"). A code passes through; nothing gives ''.
 */
export const toProfessionCode = (professionType?: string): string => {
  if (!professionType) return '';
  const code: string = UserProfession.getCode(professionType) ?? professionType;
  return UserProfession.getNormalizedCode(code) ?? code;
};
